import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import {MatProgressBarModule} from '@angular/material/progress-bar'; 
import { NgxMaskModule } from 'ngx-mask';


import { FuseSharedModule } from "@fuse/shared.module";
import { LoginComponent } from "./login.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { LoginService } from "./login.service";

const routes = [
    {
        path: "auth/login",
        component: LoginComponent,
    },
]; 

@NgModule({
    declarations: [LoginComponent],
    imports: [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,        
        FuseSharedModule,
        NgxMaskModule,
        MatProgressBarModule
    ],
    providers: [LoginService],
})
export class LoginModule {}
